import { FC } from "react";

export const Loading: FC = () => {
  return <></>;
};
